/**
 * Created by slava on 7/3/20
 */

const ExtraHandView = cc.Node.extend({
    ctor: function (extraHand) {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.extraHand = extraHand;

        this.update(true);
        extraHand.on("update", this.update.bind(this));
    },

    update: function (silent) {
        if (this.state === this.extraHand.visible) {
            return;
        }

        this.state = this.extraHand.visible;
        this.offer = this.extraHand.offer;

        if (this.state) {
            this.showCardsAnimation();
            this.amount.setString(`+${this.offer.moves}`);
            this.updatePrice();
        }

        if (this.endGameButton) {
            this.endGameButton.setVisible(!this.offer.free);
        }

        if (silent) {
            this.visible = this.state;
            this.scale = 1;
            return;
        }

        this.stopAllActions();
        if (this.state) {
            this.visible = true;
            this.setScale(0);
            this.runAction(new cc.ScaleTo(0.25, 1));
        } else {
            this.runAction(new cc.Sequence(
                new cc.ScaleTo(0.1, 0),
                new cc.CallFunc(() => {
                    this.visible = false;
                })
            ));
        }
    },

    showCardsAnimation: function () {
        const styles = cleverapps.styles.ExtraHandView;

        if (this.extraCardsAnimation) {
            return;
        }

        this.extraCardsAnimation = new cleverapps.Spine(bundles.card.jsons.extra_json);
        this.extraCardsAnimation.setAnimation(0, "idle", true);
        this.extraCardsAnimation.setAlignment(styles.extraCards);
        this.addChild(this.extraCardsAnimation);

        this.endGameButton = new cleverapps.UI.Button({
            text: Messages.get("EndGame"),
            height: styles.button.height,
            width: styles.button.width,
            onClicked: function () {
                Game.currentGame.trigger("outOfMoves", this.offer);
            }.bind(this)
        });
        this.endGameButton.setAlignment(styles.button);

        const amount = this.amount = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.EXTRA_HAND_TEXT);
        amount.setAlignment(styles.amount);
        amount.setLocalZOrder(2);
        this.extraCardsAnimation.addChild(amount);

        this.setAlignment(styles);
        this.addChild(this.endGameButton);

        cleverapps.UI.onClick(this.extraCardsAnimation, this.extraHand.onCardsClicked.bind(this.extraHand));
        cleverapps.UI.applyHover(this.extraCardsAnimation);
        cleverapps.UI.wrap(this);
    },

    updatePrice: function () {
        const styles = cleverapps.styles.ExtraHandView.price;

        if (this.offerPrice) {
            this.offerPrice.removeFromParent();
            delete this.offerPrice;
        }

        const textMessage = (this.offer.type === Product.TYPE_ADS) ? `## ${Messages.get("Watch")}` : this.offer.text;
        const text = new TextWithIcon(textMessage, {
            font: cleverapps.styles.FONTS.TEXT
        });
        text.fitTo(styles.width, styles.height);

        this.offerPrice = new cc.Scale9Sprite(bundles.small_timer.frames.small_timer_bg_png);
        this.offerPrice.setContentSize2(text.width + 2 * styles.padding.x, text.height + 2 * styles.padding.y);
        this.offerPrice.addChild(text);
        text.setAlignment(this.offerPrice.width / 2, this.offerPrice.height / 2);

        this.offerPrice.setAlignment(styles);
        this.extraCardsAnimation.addChild(this.offerPrice);
    }
});

cleverapps.styles.ExtraHandView = {
    x: -50,
    y: 12,

    extraCards: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 114 }
    },

    amount: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 45 }
    },

    price: {
        x: { align: "center" },
        y: { align: "bottom", dy: 0 },
        width: 230,
        height: 45,

        padding: {
            x: 5,
            y: 1
        }
    },

    button: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 25 },
        height: 79,
        width: 170
    }
};